<div id="AuthPageBody" class="container-fluid "
    [ngClass]="{' fullBGImage ':isFullScreeen,' mobileBGImage ':!isFullScreeen}">
    <ngx-spinner [bdColor]="SpinnerModal.bdColor" name="LoginSubmitSpinner" [fullScreen]="SpinnerModal.fullScreen"
        [size]="SpinnerModal.size" [color]="SpinnerModal.color" [type]="SpinnerModal.type">
    </ngx-spinner>

    <div class="row h-100 m-0">
        <div class="col-md-8 col-lg-8 bg-transparent d-flex justify-content-center" *ngIf="isFullScreeen">
            <ng-container *ngIf="commonQuotesArr && commonQuotesArr.length">
                <div id="TAPQ" *ngFor="let item of  commonQuotesArr">
                    <blockquote>{{item.quotes}} </blockquote>
                </div>
            </ng-container>
        </div>

        <div class="col-sm-12 col-md-4 col-lg-4 d-flex flex-column justify-content-center align-items-center loginDiv">
            <div id="LoginFormCard" class="card">
                <ng-container
                    *ngIf="isLoginShow && !isForgotPassShow && !isVerifyShow && !isNewPasswordShow && !isOTPValidation">
                    <!-- Header -->
                    <div class="card-body">
                        <div class="text-center min-h-100 d-flex justify-content-center align-items-center"
                            *ngIf="isShowImgLogo === false">
                            <img src="assets/img/StaffingGo.png" alt="Login" width="80%"
                                class="img-responsive big-logo">
                        </div>
                        <div class="text-center min-h-100 d-flex justify-content-center align-items-center"
                            *ngIf="isShowImgLogo === true">
                            <img [src]="getImgLogo | safe:'resourceUrl'" alt="Login" width="80%"
                                class="img-responsive big-logo">
                        </div>



                        <!-- Email_Mobile_Login -->
                        <ng-container *ngIf="!isCompanyEmpCodeLogin && isEmailMobileLogin">
                            <!-- Email_Verify -->
                            <div class="" *ngIf="!isShowUserList && !isValidAccount">
                                <form (submit)="fnValidCustomer(verifyEmailMobileModel,1)">
                                    <dx-form [formData]="verifyEmailMobileModel" [colCount]="12" labelLocation="top">
                                        <dxi-item [label]="{visible:false}" dataField="consEmailID"
                                            editorType="dxTextBox"
                                            [editorOptions]="{ placeholder:'MOBILE NO/ EMAIL', inputAttr: {'style': 'text-transform: lowercase'}}"
                                            [colSpan]="12">
                                            <dxi-validation-rule type="required"
                                                message="Email or mobile number is required">
                                            </dxi-validation-rule>
                                            <dxi-validation-rule type="pattern" [pattern]="commonPatter"
                                                message="Please enter valid Email or mobile number">
                                            </dxi-validation-rule>
                                        </dxi-item>
                                        <dxi-item itemType="button" [colSpan]="12" [buttonOptions]="essContinue"
                                            template="content">
                                        </dxi-item>
                                        <div *dxTemplate="let data of 'content'">
                                            <span class="dx-button-text text-uppercase">Continue</span>
                                            <dx-load-indicator class="button-indicator"
                                                [visible]="loadIndicatorVisible">
                                            </dx-load-indicator>
                                        </div>
                                    </dx-form>
                                    <!-- <p class="mt-2 mb-0 text-center btnLoginCode">
                                        <a href="javascript:void(0)" (click)="fnLoginByType(1)">Login by Employee
                                            code</a>
                                    </p> -->
                                    <p class="mt-2 mb-0 text-center btnNewRegis" *ngIf="isRegisterLinkVisible">
                                        <a href="javascript:void(0)" (click)="fnNavToReg()">Register as a New
                                            Candidate</a>
                                    </p>
                                </form>
                            </div>

                            <!-- Passward -->
                            <div class="" *ngIf="!isShowUserList && isValidAccount">
                                <form (submit)="fnConsLoginSubmit(custLoginModel)">
                                    <dx-form [formData]="custLoginModel" [colCount]="12" labelLocation="top">
                                        <dxi-item [label]="{visible:false}" dataField="userName"
                                            template="userNameTemplate" [colSpan]="12">
                                        </dxi-item>
                                        <div *dxTemplate="let data of 'userNameTemplate'">
                                            <dx-text-box [(value)]="custLoginModel.userName" readOnly="true"
                                                stylingMode="filled">
                                                <dxi-button name="edit" location="after"
                                                    [options]="emailButton"></dxi-button>
                                            </dx-text-box>
                                        </div>
                                        <dxi-item [label]="{visible:false,text: 'Password'}" dataField="password"
                                            template="userPasswordTemplate" editorType="dxTextBox"
                                            [editorOptions]="{ mode: !isPassHide ? 'password' : 'text',placeholder:'Password' }"
                                            [colSpan]="12">
                                            <dxi-validation-rule type="required"
                                                message="Password is required!"></dxi-validation-rule>
                                        </dxi-item>
                                        <div *dxTemplate="let data of 'userPasswordTemplate'">
                                            <dx-text-box [(value)]="custLoginModel.password"
                                                [mode]="!isPassHide ? 'password' : 'text'" stylingMode="filled">
                                                <dxi-button name="eye" location="after"
                                                    [options]="passwordButton"></dxi-button>
                                            </dx-text-box>
                                        </div>
                                        <dxi-item itemType="button" [colSpan]="12" [buttonOptions]="custLogin"
                                            template="content">
                                        </dxi-item>
                                        <dxi-item [colSpan]="12">
                                            <div class="text-center btnOTPFP">
                                                <a href="javascript:void(0);" (click)="fnResetPassword()">Forgot
                                                    password
                                                </a>
                                                <br>
                                                <a href="javascript:void(0);" (click)="fnResetPassword()">Login using
                                                    OTP
                                                </a>
                                            </div>
                                        </dxi-item>
                                        <div *dxTemplate="let data of 'content'">
                                            <span class="dx-button-text text-uppercase">Login</span>
                                            <dx-load-indicator class="button-indicator"
                                                [visible]="loadIndicatorVisible">
                                            </dx-load-indicator>
                                        </div>
                                    </dx-form>
                                </form>
                            </div>

                            <!-- User_Client_List -->
                            <div class="card-footer" *ngIf="isShowUserList">
                                <h6 class="font-weight-bold text-center">Select Company to proceed</h6>
                                <div class="card pointer mb-2 border"
                                    *ngFor="let item of multipleCheckInfo.dataObject.userList"
                                    (click)="fnSelectLogin(item)">
                                    <div class="card-body p-2">
                                        <div class="row">
                                            <div class="col-md-3 text-center">
                                                <div id="CustomerImage" class="userImage"
                                                    [style.background-image]="'url(' + (item.customerLogoURL ? item.customerLogoURL : 'assets/img/StaffingGo.png') + ')'">
                                                </div>
                                            </div>
                                            <div class="col-md-9 d-flex align-items-center">
                                                <p class="mb-0">{{item.customerName ? item.customerName : '-'}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <p class="mb-0 text-center">
                                    <a href="javascript:void(0);" (click)="fnBackToLogIn()"> Back to Login? </a>
                                </p>
                            </div>
                        </ng-container>


                        <!-- Company_Employee_Code -->
                        <ng-container *ngIf="isCompanyEmpCodeLogin && !isEmailMobileLogin">
                            <div class="" *ngIf="!isValidCompanyCode">
                                <form (submit)="fnValidCustomer(verifyEmailMobileModel,2)">
                                    <dx-form [formData]="verifyEmailMobileModel" [colCount]="12" labelLocation="top">
                                        <dxi-item itemType="group" [colSpan]="12" [colCount]="1">
                                            <dxi-item [label]="{visible:false}" dataField="customerKey"
                                                editorType="dxTextBox"
                                                [editorOptions]="{ placeholder:'Company Code..'}">
                                                <dxi-validation-rule type="required" message="Company Code is required">
                                                </dxi-validation-rule>
                                            </dxi-item>
                                            <dxi-item [label]="{visible:false}" dataField="consEmailID"
                                                editorType="dxTextBox"
                                                [editorOptions]="{ placeholder:'Employee Code..'}">
                                                <dxi-validation-rule type="required"
                                                    message="Employee Code is required">
                                                </dxi-validation-rule>
                                            </dxi-item>
                                            <dxi-item itemType="button" [buttonOptions]="essContinue"
                                                template="content">
                                            </dxi-item>
                                        </dxi-item>

                                        <div *dxTemplate="let data of 'content'">
                                            <span class="dx-button-text upperTT">Continue</span>
                                            <dx-load-indicator class="button-indicator"
                                                [visible]="loadIndicatorVisible">
                                            </dx-load-indicator>
                                        </div>
                                    </dx-form>

                                    <p class="mt-2 mb-0 text-center btnLoginEmailMobile">
                                        <a href="javascript:void(0)" (click)="fnLoginByType(2)">Login by Email or Mobile
                                        </a>
                                    </p>
                                </form>
                            </div>

                            <div class="" *ngIf="isValidCompanyCode">
                                <form id="loginForm" (submit)="fnConsLoginSubmit(custLoginModel)">
                                    <dx-form [formData]="custLoginModel" [colCount]="12" labelLocation="top">
                                        <dxi-item [label]="{visible:false}" dataField="customerKey"
                                            template="customerTemplate" [colSpan]="12">
                                        </dxi-item>
                                        <div *dxTemplate="let data of 'customerTemplate'">
                                            <dx-text-box [(value)]="custLoginModel.customerKey" readOnly="true"
                                                stylingMode="filled">
                                            </dx-text-box>
                                        </div>
                                        <dxi-item [label]="{visible:false}" dataField="userName"
                                            template="userNameTemplate" [colSpan]="12">
                                        </dxi-item>
                                        <div *dxTemplate="let data of 'userNameTemplate'">
                                            <dx-text-box [(value)]="custLoginModel.userName" readOnly="true"
                                                stylingMode="filled">
                                                <dxi-button name="edit" location="after"
                                                    [options]="codeButton"></dxi-button>
                                            </dx-text-box>
                                        </div>
                                        <dxi-item [label]="{visible:false,text: 'Password'}" dataField="password"
                                            template="userPasswordTemplate" editorType="dxTextBox"
                                            [editorOptions]="{ mode: !isPassHide ? 'password' : 'text',placeholder:'Password' }"
                                            [colSpan]="12">
                                            <dxi-validation-rule type="required" message="Password is required!">
                                            </dxi-validation-rule>
                                        </dxi-item>
                                        <div *dxTemplate="let data of 'userPasswordTemplate'">
                                            <dx-text-box [(value)]="custLoginModel.password"
                                                [mode]="!isPassHide ? 'password' : 'text'" stylingMode="filled">
                                                <dxi-button name="eye" location="after"
                                                    [options]="passwordButton"></dxi-button>
                                            </dx-text-box>
                                        </div>
                                        <dxi-item itemType="button" [colSpan]="12" [buttonOptions]="custLogin"
                                            template="content">
                                        </dxi-item>
                                        <div *dxTemplate="let data of 'content'">
                                            <span class="dx-button-text">Login</span>
                                            <dx-load-indicator class="button-indicator"
                                                [visible]="loadIndicatorVisible">
                                            </dx-load-indicator>
                                        </div>
                                    </dx-form>
                                </form>
                            </div>
                        </ng-container>
                    </div>
                </ng-container>




                <!-- forgot_password -->
                <div class="card-body"
                    *ngIf="isForgotPassShow && !isLoginShow && !isVerifyShow && !isNewPasswordShow && !isOTPValidation">
                    <app-forgot-password
                        *ngIf="isForgotPassShow && validEmailInfo.cid && validEmailInfo.consEmailID && validEmailInfo.consultantID"
                        [(validEmailInfo)]="validEmailInfo" (emitPassRes)="fnGetPassRes($event)">
                    </app-forgot-password>
                </div>

                <!-- Account_verify -->
                <div class="card-body"
                    *ngIf="isVerifyShow && !isLoginShow && !isNewPasswordShow && !isForgotPassShow && !isOTPValidation">
                    <app-essaccount-verify
                        *ngIf="isVerifyShow && verifyACC.cid && verifyACC.consEmailID && verifyACC.consultantID"
                        [validEmailInfo]="verifyACC" (emitRes)="fnGetRes($event)">
                    </app-essaccount-verify>
                </div>

                <!-- Change_Password -->
                <div class="card-body"
                    *ngIf="!isVerifyShow && !isLoginShow && isNewPasswordShow && !isForgotPassShow && !isOTPValidation">
                    <app-essnew-password
                        *ngIf="isNewPasswordShow && passwordInputModel.cid && passwordInputModel.consEmailID && passwordInputModel.consultantID"
                        [passwordModel]="passwordInputModel" (emitNewPassRes)="fnGetNewPass($event)">
                    </app-essnew-password>
                </div>

                <!-- 2FA -->
                <div class="card-body" *ngIf="isOTPValidation">
                    <div class="text-center">
                        <img src="assets/img/StaffingGo.png" alt="Login" width="80%" class="img-responsive big-logo"
                            *ngIf="isShowImgLogo === false">
                        <img [src]="getImgLogo | safe:'resourceUrl'" alt="Login" width="80%"
                            class="img-responsive big-logo" *ngIf="isShowImgLogo === true">
                    </div>
                    <div class="fz-18 text-center my-3 alert alert-success">
                        <b>{{msg ? msg : 'Please, Enter OTP to verify
                            your account'}}</b>
                    </div>
                    <form (submit)="fnSubmitOTP()">
                        <dx-form #otpForm [formData]="otpModal" [colCount]="12" labelLocation="top">
                            <dxi-item itemType="group" [colSpan]="12">
                                <dxi-item template="otpTemplate" [label]="{visible:false}" dataField="otp"
                                    editorType="dxTextBox" [colSpan]="12" [isRequired]="true"
                                    [editorOptions]="{minLength:6,maxLength:6,placeholder:'Enter OTP'}">
                                    <dxi-validation-rule type="required" message="OTP is required">
                                    </dxi-validation-rule>
                                </dxi-item>
                            </dxi-item>
                            <dxi-item itemType="group" [colSpan]="12" [colCount]="12">
                                <dxi-item itemType="button" [colSpan]="12" [buttonOptions]="SubmitOTP"
                                    template="content">
                                </dxi-item>
                            </dxi-item>
                            <div *dxTemplate="let data of 'content'">
                                <span class="dx-button-text text-uppercase">Submit</span>
                                <dx-load-indicator class="button-indicator" [visible]="loadIndicatorVisible">
                                </dx-load-indicator>
                            </div>
                            <div *dxTemplate="let data of 'otpTemplate'" class="text-center">
                                <ng-otp-input (onInputChange)="onOtpChange($event)" [config]="config"
                                    required></ng-otp-input>
                            </div>


                        </dx-form>
                        <p class="mb-0 mt-3 text-center">
                            <a href="javascript:void(0);"
                                [ngStyle]="{'pointer-events':resendDisabled ? 'none' : 'initial'}"
                                (click)="fnResendOTP()">
                                Resend OTP {{resendDisabled ? '(' + timer + 's)' : ''}} </a>
                        </p>
                    </form>
                </div>



                <!-- Footer -->
                <div id="footerCard" class="card-footer border-0 text-muted ">
                    <div class="fz-18 text-center" *ngIf="isWhiteLabled == 'No'"><b>Powered By</b></div>
                    <div class="text-center my-2" *ngIf="isWhiteLabled == 'No'">
                        <img [src]="footerImg ? footerImg : 'assets/img/PoweredBy.png'" alt="PoweredBy" width="100px"
                            class="img-responsive big-logo">
                    </div>
                    <!-- <p>© 2024 StaffingGo Pvt Ltd.</p> -->
                    <p class="mt-2">
                        <!-- <a target="_blank" href="#">Cookie Policy</a> | -->
                        <a target="_blank" href="https://staffinggo.in/terms-n-conditions">Terms of Use</a> |
                        <a target="_blank" href="https://staffinggo.in/PrivacyPolicy">Privacy Policy</a>
                    </p>
                    <div class="row" *ngIf="displayAppLinks && !isShowUserList">
                        <div class="col-md-9 text-center mx-auto">
                            <div class="row d-flex align-items-center">
                                <div class="col p-0">
                                    <a [href]="appleStore" target="_blank"> <img
                                            src="assets/img/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.svg"
                                            width="85%" alt="Apple"></a>
                                </div>
                                <div class="col p-0">
                                    <a [href]="playStore" target="_blank"> <img src="assets/img/google-play-badge.png"
                                            width="100%" alt="Google">
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>





<dx-popup [hideOnOutsideClick]="false" [showTitle]="true" title="Enter OTP" [width]="550" [height]="240"
    (onHiding)="popup_hiding()" [dragEnabled]="false" [visible]="false">
    <ngx-spinner [bdColor]="SpinnerModal.bdColor" name="otpSpinner" [fullScreen]="SpinnerModal.fullScreen"
        [size]="SpinnerModal.size" [color]="SpinnerModal.color" [type]="SpinnerModal.type">
    </ngx-spinner>
    <div class="row">
        <div class="col-12 col-sm-12 col-md-12 col-lg-12">
            <h5 *ngIf="msg">{{msg}}</h5>
            <form (submit)="fnSubmitOTP()">
                <dx-form #otpForm [formData]="otpModal" [colCount]="12" labelLocation="top">
                    <dxi-item itemType="group" [colSpan]="12">
                        <dxi-item [label]="{visible:false}" dataField="otp" editorType="dxTextBox" [colSpan]="12"
                            [isRequired]="true" [editorOptions]="{minLength:6,maxLength:6,placeholder:'Enter OTP'}">
                            <dxi-validation-rule type="required" message="OTP is required">
                            </dxi-validation-rule>
                        </dxi-item>
                    </dxi-item>
                    <dxi-item itemType="group" [colSpan]="12" [colCount]="12">
                        <dxi-item itemType="button" [colSpan]="4" [buttonOptions]="CancelPopup">
                        </dxi-item>
                        <dxi-item itemType="button" [colSpan]="4" [buttonOptions]="ResendOTP">
                        </dxi-item>
                        <dxi-item itemType="button" [colSpan]="4" [buttonOptions]="SubmitOTP">
                        </dxi-item>
                    </dxi-item>
                </dx-form>
            </form>
        </div>
    </div>
</dx-popup>